import { api } from '../axios';

const BASE_URL = 'https://api-liquidity.airight.io';

export const getApr = async (params: string) => {
  return await api.get(`/v1/apy?${params}`, {
    withCredentials: false,
    baseURL: BASE_URL,
  });
};

export const getStatisticsAiri = async () => {
  return await api.get('/v1/airi-info', {
    withCredentials: false,
    baseURL: BASE_URL,
  });
};

export const getGraphData = async (params?: string) => {
  const url = params ? `/v1/liquidity-history?${params}` : '/v1/liquidity-history?';
  return await api.get(url, {
    withCredentials: false,
    baseURL: BASE_URL,
  });
};

export const getBnbPrice = async () => {
  return await api.get('https://price.market.orai.io/simple/price?ids=wbnb&vs_currencies=usd', {
    withCredentials: false,
  });
};
